import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Profile } from "types/Profile";

export const PROFILE = "profile";

export type FetchProfileParams = {
	orgId: string;
	enabled: boolean;
};

const fetchProfile = ({ orgId }: FetchProfileParams) =>
	axios.get<Profile>(`/job/company/api/${orgId}/profile`).then((response) => response.data);

export const useProfile = (params: FetchProfileParams) => {
	return useQuery({
		queryKey: [PROFILE, params],
		queryFn: () => fetchProfile(params),
		enabled: params.enabled,
	});
};
